import { createModel } from "hox";
import { useState, useEffect } from "react";
import { IUserSearch, IUserDetial, IUserFields } from "./userType"
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { userService } from "./userService";
import { ISearchPage } from "@/types/AppTypes";
import { transPgToPagination } from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { globalPrompt } from "@/components/message";
import { convertRes2Blob } from "@/utils/exportFile";
interface IUserType {
    visible: boolean,
    mode: "add" | "edit"
}
export enum IUserTypes {
    USER = "0",
    CHEF = "1"
}
export const useUserModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IUserDetial[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IUserFields>({});
    //抽屉框
    const initShopDrawer: IUserType = { visible: false, mode: "add" }
    const [visibleDrawer, setVisibleDrawer] = useState<IUserType>(initShopDrawer);
    const setIVisibleDrawer = (str?: "add" | "edit") => setVisibleDrawer(str ? { visible: true, mode: str } : initShopDrawer);

    // const 
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedRow, setSelectedRow] = useState<IUserDetial>({});
    const [tabActive, setTabActive] = useState<IUserTypes>(IUserTypes.USER); //tabs 选中
    const [loading, setLoading] = useState<boolean>(false);
    const loadData = async (page?: ISearchPage, searchValue: IUserFields = searchParam, type = tabActive) => {
        setLoading(true)
        const searchParams = {
            ...searchValue,
            type,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await userService.page(searchParams);
        let { data, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setTabActive(type)
        setDataSource(data)
        setLoading(false)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IUserFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //编辑用户
    const editDetail = useLockFn(async (params: IUserFields) => {
        let { retData } = await userService.update({ ...params, type: tabActive })
        if (retData) {
            loadData();
            globalPrompt("message", { text: "用户编辑成功", type: "success" })
        } else {
            globalPrompt("message", { text: "用户编辑失败", type: "success" })

        }
    })
    //编辑用户
    const insertDetail = useLockFn(async (params: IUserFields) => {
        let { retData } = await userService.insert({ ...params, type: tabActive })
        if (retData) {
            loadData();
            globalPrompt("message", { text: "用户新增成功", type: "success" })
        } else {
            globalPrompt("message", { text: "用户新增失败", type: "success" })

        }
    })

    //删除用户
    const removeUser = useLockFn(async (params: string) => {
        let { retData } = await userService.remove(params)
        loadData();
        globalPrompt("message", { text: "删除成功", type: "success" })
    })

    //导出
    const userExport = async () => {
        let result = await userService.export(tabActive);
        convertRes2Blob(result)
    }

    return {
        dataSource, loading,
        searchParam,
        initPgCfg,
        pgCfg,
        selectedRowKeys,
        visibleDrawer,
        selectedRow,
        setDataSource,
        setSearchParam,
        setPgCfg,
        loadData,
        updateSearchParam,
        resetSearchParam,
        setSelectedRowKeys,
        setVisibleDrawer,
        editDetail,
        insertDetail,
        setIVisibleDrawer,
        setSelectedRow,
        removeUser,
        tabActive, setTabActive,
        userExport
    }
})